import { version as appVersion } from '../../package.json';
import i18n from '../i18n';

/** Where users write for help; the same address as in the footer of our emails. */
export const SUPPORT_EMAIL = 'help@taman.tech';

interface SupportContext {
  projectName?: string;
  projectId?: number;
  versionId?: number;
}

/**
 * `mailto:` link to support with the subject and a short diagnostics block already filled in
 * (where the user was, app version, browser), so the first reply doesn't have to ask for them.
 */
export function buildSupportMailto(context: SupportContext = {}): string {
  const subject = context.projectName
    ? i18n.t('support.subjectProject', { project: context.projectName })
    : i18n.t('support.subject');

  const details = [
    context.projectId != null &&
      `${i18n.t('support.project')}: ${context.projectName ?? ''} #${context.projectId}` +
        (context.versionId != null ? `, ${i18n.t('support.version')} #${context.versionId}` : ''),
    `${i18n.t('support.page')}: ${window.location.href}`,
    `${i18n.t('support.appVersion')}: ${appVersion}`,
    `${i18n.t('support.browser')}: ${navigator.userAgent}`,
  ].filter(Boolean);

  const body = [i18n.t('support.bodyPrompt'), '', '', '', '———', ...details].join('\n');
  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
